module.exports = __webpack_public_path__ + "static/media/Email_confirmation.4a0e4515.png";